import { render } from "./ActualizareDate.vue?vue&type=template&id=2070743a&scoped=true&ts=true"
import script from "./ActualizareDate.vue?vue&type=script&lang=ts"
export * from "./ActualizareDate.vue?vue&type=script&lang=ts"

import "./ActualizareDate.vue?vue&type=style&index=0&id=2070743a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2070743a"]])

export default __exports__